import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.999 14v-4h4v4h-4zm-.001-5V5h4v4h-4zM0 4V0h4v4H0zm4.998 0V0h4v4h-4zm5 0V0H14v4H9.998z",
      fill: "#fff"
    })
  }));
};
export default SvgComponent;